export default "__VITE_ASSET__CT67hvEx__"